// Ovládací tlačítka okna (pravý horní roh hlavičky).
// Renderuje se jen tlačítko, ke kterému je předán handler — sada se tak mění
// podle stavu okna (docked vs floating) bez mrtvých tlačítek.

import { Icon } from '@/shared/ui/icon';

export interface WindowControlsProps {
  /** Základní okno své skupiny (jen ono umí „Vrátit do plochy"). */
  readonly isBase: boolean;
  /** Osamostatnit (docked → floating, nebo pop ze sub-stacku). */
  readonly onDetach?: () => void;
  /** Vrátit do plochy / původního stacku (jen základní okno floating skupiny). */
  readonly onDock?: () => void;
  readonly onMinimize?: () => void;
  readonly onMaximize?: () => void;
  readonly onRestore?: () => void;
  readonly onClose?: () => void;
}

/** Zastaví bublání pointer-down, aby klik na tlačítko nezahájil drag okna. */
function stopPointer(e: React.PointerEvent) {
  e.stopPropagation();
}

export function WindowControls({
  isBase,
  onDetach,
  onDock,
  onMinimize,
  onMaximize,
  onRestore,
  onClose,
}: WindowControlsProps) {
  return (
    <span className="pwm-wc" onPointerDown={stopPointer}>
      {isBase && onDock ? (
        <button
          type="button"
          className="pwm-wc-btn"
          data-on
          title="Vrátit do plochy"
          onClick={onDock}
        >
          <Icon name="dock" size={13} />
        </button>
      ) : onDetach ? (
        <button type="button" className="pwm-wc-btn" title="Osamostatnit okno" onClick={onDetach}>
          <Icon name="detach" size={13} />
        </button>
      ) : null}

      {onMinimize ? (
        <button type="button" className="pwm-wc-btn" title="Minimalizovat" onClick={onMinimize}>
          <Icon name="minus" size={13} />
        </button>
      ) : null}

      {onRestore ? (
        <button type="button" className="pwm-wc-btn" title="Obnovit" onClick={onRestore}>
          <Icon name="restore" size={12} />
        </button>
      ) : onMaximize ? (
        <button type="button" className="pwm-wc-btn" title="Maximalizovat" onClick={onMaximize}>
          <Icon name="maximize" size={12} />
        </button>
      ) : null}

      {onClose ? (
        <button type="button" className="pwm-wc-btn" data-danger title="Zavřít" onClick={onClose}>
          <Icon name="x" size={13} />
        </button>
      ) : null}
    </span>
  );
}
